import React, { memo, useCallback, useEffect, useMemo } from 'react';
import parse from 'html-react-parser';
import { log } from 'log';
import { equals } from 'ramda';
import { componentService } from 'js/services/component.service';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { getHTMLParserOptions } from 'js/utils/getHTMLParserOptions.util';
import { getBackboneReplacerViews } from 'js/backbone/components/BackboneReplacer';

import { dispatcher } from 'dispatcher';

/**
 * @param props {Object}
 * @param [props.id] {string}
 * @param [props.content] {string}
 * @param [props.popupId] {string}
 * @param [props.className] {string}
 */
export const WebContentInnerBare = ({ id, content, popupId, className = '' }) => {
    const replacers = getBackboneReplacerViews();
    const components = componentService.getWebContentComponents();
    const closePopups = useSmartClosePopups();
    const onClick = useCallback((event) => {
        const { target: { target } } = event;
        const isInTheSameWindow = target === '_self';

        if (popupId && isInTheSameWindow) {
            closePopups(popupId);
        }
    }, [popupId, closePopups]);

    const { options, scripts } = useMemo(() => getHTMLParserOptions({
        components,
        replacers,
        linkAttributes: { onClick }
    }), [components, onClick, replacers]);

    useEffect(() => {
        for (const script of scripts) {
            try {
                document.body.appendChild(script);
            } catch (e) {
                log('error', `Error in webcontent ${id} script`, e);
            }
        }

        if (id) {
            dispatcher.dispatch('webContent:rendered', id);
        }

        return () => {
            for (const script of scripts) {
                try {
                    document.body.removeChild(script);
                } catch (e) {
                    log('error', `Unable to remove script from webcontent ${id}`, e);
                }
            }
        };
    }, [id, scripts]);

    return (
        <div
            className={`${className}`}
            {...id ? { 'data-web-content-id': id } : {}}
        >
            <article>{parse(content.toString(), options)}</article>
        </div>
    );
};

export const WebContentInner = memo(WebContentInnerBare, equals);
